import { render, staticRenderFns } from "./procurement.vue?vue&type=template&id=7014a1d4"
import script from "./procurement.vue?vue&type=script&lang=js"
export * from "./procurement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports